import { create } from 'zustand';
import { type PersonLabelStore } from '@/entities/person';


export const usePersonLabelStore = create<PersonLabelStore>((set, get) => ({
    personLabels: [],
    setPersonLabels: (personLabels) => set({ personLabels }),
    addPersonLabel: (personLabel) => set((state) => ({ personLabels: [...state.personLabels, personLabel] })),
    deletePersonLabel: (id) => set((state) => ({ personLabels: state.personLabels.filter((pl) => pl.id !== id) })),
    getLabelsByPerson: (personId) => get().personLabels.filter((pl) => pl.person_id === personId),
    getPersonsByLabel: (labelId) => get().personLabels.filter((pl) => pl.label_id === labelId),
    deletePersonLabelsByPerson: (personId) => set((state) => ({
        personLabels: state.personLabels.filter((pl) => pl.person_id !== personId)
    })),
}));
